/**
 * App 下载地址
 */
export const AppDownLoadAddress = {
  APP_STORE: "https://apps.apple.com/nz/app/rockflow/id1599189662",
  APP_STORE_CHINA_MAINLAND:
    "https://apps.apple.com/cn/app/rockflow/id6463616723",
  GOOGLE_PALY:
    "https://play.google.com/store/apps/details?id=team.flowai.android",
  OFFICIAL: "https://web-cdn.rockflow.tech/apk/rockflow_android.apk",
  HOME_PAGE_DOWNLOAD: (inviteCode?: string, _query?: string) => {
    let query = inviteCode ? `?inviteCode=${inviteCode}` : "";
    if (_query) {
      query = _query;
    }
    return `${process.env.NEXT_PUBLIC_APP_HOME_PAGE}/download${query}`;
  },
};
